import { Chip } from "@heroui/react";
import { BeakerIcon, CheckIcon } from "@heroicons/react/24/outline";
import { ChipRemoveButton } from "./ChipRemoveButton";

type MadeItState = "made" | "not-tried";

interface MadeItChipProps {
    state: MadeItState;
    label?: string;
    onRemove?: () => void;
}

export const MadeItChip = ({ state, label, onRemove }: MadeItChipProps) => {
    const isRemovable = !!onRemove;
    const isMade = state === "made";
    const text = label ?? (isMade ? (isRemovable ? "I've made it" : "Made it") : "Not yet tried");
    const Icon = isMade ? CheckIcon : BeakerIcon;

    return (
        <Chip
            size={isRemovable ? "md" : "lg"}
            color={isMade ? undefined : "warning"}
            variant={isRemovable ? "soft" : undefined}
            className={`${isMade ? "chip--mystic" : ""}${isRemovable ? " active-filter-chip" : ""}`.trim() || undefined}
        >
            <Icon className="w-3.5 h-3.5" />
            <Chip.Label>{text}</Chip.Label>
            {onRemove && <ChipRemoveButton label={text} onPress={onRemove} />}
        </Chip>
    );
};
